import {Typography,Paper,Box,LinearProgress} from "@deere/fuel-react"

export default function LinearProgressIndicator({title,subtitle}){
    return <Paper>
                <Box
                    alignItems="center"
                    display="flex"
                    flexDirection="column"
                    height={200}
                    justifyContent="center"
                    p={4}
                >
                    <Box maxWidth={100} width="100%">
                        <LinearProgress size="md" value={10} variant="indeterminate" />
                    </Box>
                    <Typography gutterBottom style={{marginTop: "1rem"}} variant="h3">
                        {title}
                    </Typography>
                    <Typography variant="subtitle2">
                        {subtitle}
                    </Typography>
                </Box>
            </Paper>

}